<style scoped lang="less">
.my-table {
    padding-bottom: 30px;
}
.pagination {
    background: white;
    position: absolute;
    z-index: 1;
    left: 0;
    bottom: 0;
    padding: 14px 14px 20px;
    width: 100%;
}
</style>

<template>
    <div>
        <slot />
        <div class="block my-table">
            <el-pagination class="pagination z-depth-1" layout="total, prev, pager, next, jumper" :total="total" @current-change="changePage" :current-page="pageNum+1" :page-size="pageSize">
            </el-pagination>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            pageNum: 0,
            total: 0,
        };
    },
    props: {
        pageSize: {
            type: Number,
            default: 50,
        },
    },
    // html渲染数据之后，不然无法获取dom
    mounted() {
        this.fetchData();
    },
    methods: {
        refetchData() {
            if (this.pageNum !== 0) {
                // 这里会直接触发changePage
                this.changePage(1);
            } else {
                this.$emit("fetch-data");
            }
        },

        changePage(page) {
            this.pageNum = page - 1;

            this.$emit("fetch-data");
        },

        submitTotal(total) {
            this.total = total;
        },

        fetchData() {
            this.$emit("fetch-data");
        },
    },
};
</script>
